


















import {
  computed,
  defineComponent,
  getCurrentInstance,
  ref,
  PropType,
} from '@vue/composition-api'

import ExportImportButton from '@/components/molecules/h/ExportImportButton.vue'
import TitleAndManipulate from '@/components/organisms/h/TitleAndManipulate.vue'
import {
  outputCondUseInfoList,
  NewStoreBulkOrderArrivalExtractCondition,
} from '@/types/entities'
export default defineComponent({
  components: {
    TitleAndManipulate,
    ExportImportButton,
  },
  props: {
    outputUseList: {
      type: Array as PropType<outputCondUseInfoList>,
      default: () => [],
    },
    totalCount: {
      type: String as PropType<string>,
      default: null,
    },
    exportSpinner: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(_, context) {
    const instance = getCurrentInstance()
    if (!instance) {
      // should be called in setup
      return
    }
    const { $i18n } = instance.proxy

    const requestExport = () => {
      context.emit('request-export')
    }
    const requestImport = () => {
      context.emit('request-import')
    }
    const changeExtractCondition = (cond: NewStoreBulkOrderArrivalExtractCondition) => {
      // console.log('changeExtractCondition', { cond })
      context.emit('change-extract-condition', cond)
    }

    const changeOutputCondition = (
      cond: NewStoreBulkOrderArrivalExtractCondition) => {
      context.emit('change-output-condition', cond)
    }

    return {
      requestExport,
      requestImport,
      changeExtractCondition,
      changeOutputCondition,
    }
  },
})
